module.exports = __webpack_public_path__ + "img/12_110.7bd9619f.png";